import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import SiteLayout from "@/components/site/SiteLayout";

export default function VideosPage() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/videos", { params: { limit: 60 } })
      .then((r) => setVideos(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SiteLayout>
      <div className="max-w-7xl mx-auto px-4 py-10">
        <div className="border-b-4 border-[#2E7D32] pb-4 mb-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#2E7D32]">వీడియో</div>
          <h1 className="font-heading-te text-4xl md:text-5xl font-black mt-1">వీడియో వార్తలు</h1>
        </div>
        {loading ? (
          <div className="text-center py-16 font-body-te">లోడ్ అవుతోంది...</div>
        ) : videos.length === 0 ? (
          <div className="text-center py-16 font-body-te text-[#4A4A4A]" data-testid="videos-empty">
            ప్రస్తుతం వీడియోలు లేవు.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="videos-grid">
            {videos.map((v) => (
              <div key={v.id} className="border border-[#E5E4DC] bg-white" data-testid={`video-item-${v.id}`}>
                <div className="aspect-video">
                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${v.youtube_id}`}
                    title={v.title}
                    frameBorder="0"
                    allowFullScreen
                  />
                </div>
                <div className="p-4">
                  <h3 className="font-heading-te font-bold text-lg line-clamp-2">{v.title}</h3>
                  {v.description && (
                    <p className="mt-2 font-body-te text-sm text-[#4A4A4A] line-clamp-3">{v.description}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </SiteLayout>
  );
}
